import React from 'react';

import useSearchSort from '../hooks/store/useSearchSort';
import Component from '../components/SortDropdown';

const SortDropdown = () => {

    const {
        searchSortOptions,
        searchSortSelectedOption,
        applySearchSort,
    } = useSearchSort();

    return (
        <Component
            options={searchSortOptions}
            selected={searchSortSelectedOption}
            applySearchSort={applySearchSort}
        />
    );

};

export default SortDropdown;
